module.exports = __webpack_public_path__ + "img/cryptocompare.2a1e1438.png";